import { useMemo } from "react";
import { useSearchParams } from "react-router";

import { getSearchQuery } from "components/SearchInput/helpers";
import useTableSort from "components/Table/useTableSort";
import { SearchQueryOrderDirection } from "types/generated";

import {
  SORT_CONFIG,
  VCS_AGENT_POOL_AGENTS_COLUMN_ID,
  VCS_AGENT_POOL_AGENTS_TABLE_FILTERS_STORAGE_KEY,
} from "./constants";
import { sortVcsAgentConnections } from "./helpers";
import { VcsAgentConnectionRow } from "./types";

export const useSortingVcsAgentConnections = (agentConnections: VcsAgentConnectionRow[] = []) => {
  const [searchParams] = useSearchParams();
  const searchInput = getSearchQuery(searchParams);

  const { sortDescriptor } = useTableSort({
    filtersOrderSettingsKey: VCS_AGENT_POOL_AGENTS_TABLE_FILTERS_STORAGE_KEY,
    sortConfig: SORT_CONFIG,
    initialSortOption: VCS_AGENT_POOL_AGENTS_COLUMN_ID.AGENT_ID,
    initialSortDirection: SearchQueryOrderDirection.Asc,
  });

  const filteredAgentConnections = useMemo(() => {
    let filtered = [...agentConnections];

    if (searchInput) {
      filtered = filtered.filter((agentConnection) =>
        agentConnection.id.toLowerCase().includes(searchInput.toLowerCase())
      );
    }

    if (sortDescriptor.column) {
      filtered = sortVcsAgentConnections(filtered, sortDescriptor);
    }

    return filtered;
  }, [agentConnections, searchInput, sortDescriptor]);

  return {
    filteredAgentConnections,
  };
};
